
import { Params } from "@angular/router";
import { Subject } from "rxjs";
import { AtgardStatuses as AtgardStatusViewModel } from "../../../models/atgardstatus/atgardstatuses-models";

export interface IAtgardStatus {
    visible: () => boolean;
    header: string;
    tooltips: IAtgardStatusTooltip[];
    icons: IAtgardStatusIcon[];
}

export interface IAtgardStatusTooltip {
    iconClass?: string;
    header: string;
    routeText?: string;
    text: string;
    visible?: boolean;
    hideWhenDirty?: boolean;
    bold?: boolean;
    link?: {
        route: string | any[];
        queryParams?: Params;
        target?: string;
        onClick?: (event: Event) => void;
    };
}

export interface IAtgardStatusIcon {
    visible: boolean;
    incomplete?: boolean;
    warning?: boolean;
    iconclass1: string;
    iconclass2?: string;
    customTriggers?: string;
}

export class AtgardStatusBase {
    header: string;
    status: AtgardStatusViewModel;
    clicked = new Subject<IAtgardStatus>();
    constructor(model: AtgardStatusViewModel) {
        this.status = model;
    }
}
